<template>
  <sidebar-link :href="latestsUrl">Latest Mixes</sidebar-link>
  <sidebar-link :href="allUrl">All Mixes</sidebar-link>
</template>

<script>
import SidebarLink from './sidebar_link.vue'

export default {
  components: { SidebarLink },
  props: {
    artist: { type: Object, default: null },
    urlPrefix: { type: String, default: '' },
  },
  computed: {
    latestsUrl() {
      return this.artist ? `${this.urlPrefix}/artists/${this.artist.id}/latest` : '/latest'
    },
    allUrl() {
      return this.artist ? `${this.urlPrefix}/artists/${this.artist.id}/all` : '/all'
    },
  }
}
</script>
